import { useMutation } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";

const ZIP_TAX_RATE_KEY = ["pdfExport", "zipTaxRate"] as const;

/** Fetch the ZipTax suggestion for an address (the estimate's current address). */
export function useZipTaxRateMutation() {
  return useMutation({
    mutationKey: ZIP_TAX_RATE_KEY,
    mutationFn: async (address: string) => {
      const response = await estimateProvider.getZipTaxRate(address);
      return response.data?.zipTaxRate;
    },
  });
}
